import React from "react"
import { Link } from "react-router-dom"

export default function ServiceCategoryCard({
  title,
  description,
  image,
  icon,
  link,
}) {
  return (
    <article className="group overflow-hidden rounded-3xl bg-white shadow-md transition-all duration-300 hover:-translate-y-2 hover:shadow-2xl">
      
      {/* Image */}
      <div className="relative h-72 overflow-hidden">
        <img
          src={image}
          alt={title}
          loading="lazy"
          className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-110"
        />

        <div className="absolute inset-0 bg-black/20" />
      </div>

      {/* Content */}
      <div className="p-8">
        {icon && (
          <div className="mb-5 flex h-14 w-14 items-center justify-center rounded-full bg-[#b8955d] text-2xl text-white">
            {icon}
          </div>
        )}

        <h3 className="mb-4 text-2xl font-semibold text-gray-900">
          {title}
        </h3>

        <p className="mb-6 leading-relaxed text-gray-600">
          {description}
        </p>

        <Link
          to={link}
          aria-label={`Découvrir ${title}`}
          className="inline-flex items-center rounded-full bg-[#b8955d] px-6 py-3 font-medium text-white transition-all duration-300 hover:bg-[#9f7d48]"
        >
          Découvrir
        </Link>
      </div>
    </article>
  )
}